import { createContext, useContext } from 'react';

export interface TeamContextType {
  teamName: string;
}

export const TeamContext = createContext<TeamContextType | undefined>(undefined);

export function useTeamContext(): TeamContextType {
  const context = useContext(TeamContext);
  if (!context) {
    throw new Error('useTeamContext must be used within a TeamContext provider (ParticipantLayout)');
  }
  return context;
}
